import { render, staticRenderFns } from "./safety-and-outings-form.vue?vue&type=template&id=3322f4ea&scoped=true"
import script from "./safety-and-outings-form.vue?vue&type=script&lang=js"
export * from "./safety-and-outings-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322f4ea",
  null
  
)

export default component.exports